import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { ScopeGroup } from "../../../types/models/ScopeGroup";
import RoleAssignmentListItem from "../../../../auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: ScopeGroup;
};

const ScopeGroupTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'roleAssignment');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="ScopeGroup-tabs"
            >
                { session.hasPermission('', 'applications/auth/entities/RoleAssignments/list/view') &&
                    <Tab label={t`Role Assignments`} value="roleAssignment"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/auth/entities/RoleAssignments/list/view') &&
                <TabPanel value={tabValue} index="roleAssignment" data-testid="RoleAssignment-tab">
                    <RoleAssignmentListItem scopeGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default ScopeGroupTabs;
